const ProductSideBarConfigB2B = [
  {
    t: "商品資訊",
    label: "商品資訊",
    EN: "Product Information",
    JP: "製品情報",
    href: "/商品資訊",
    children: [
      {
        label: "全站產品",
        EN: "All Products",
        JP: "全製品一覧",
        href: "商品資訊/",
      },
      {
        label: "產業類別",
        EN: "Industry Area",
        JP: "業種から探す",
        href: "/商品資訊/產業類別",
        // login: "required",
        children: [
          {
            EN: "Food Manufacturing",
            JP: "食品製造工場",
            label: "食品工廠",
            href: "/商品資訊/產業類別/食品工廠",
            login: "required",
            children: [
              {
                EN: "Agricultural Products (Vegetables / Fruits / Grains)",
                JP: "農産物（野菜／果物／穀物）",
                label: "農產品(蔬菜/水果/穀物)",
                href: "/商品資訊/產業類別/食品工廠/農產品(蔬菜/水果/穀物)",
              },
              {
                EN: "Livestock Products (Meat / Eggs / Dairy)",
                JP: "畜産品（食肉／卵／乳製品）",
                label: "畜牧(肉品/蛋/奶)",
                href: "/商品資訊/產業類別/食品工廠/畜牧(肉品/蛋/奶)",
              },
              {
                EN: "Seafood Products (Fish / Shrimp)",
                JP: "水産物（魚／エビ）",
                label: "水產(魚/蝦)",
                href: "/商品資訊/產業類別/食品工廠/水產(魚/蝦)",
              },
              {
                EN: "Sauces / Seasonings",
                JP: "ソース／調味料",
                label: "醬料/調味品",
                href: "/商品資訊/產業類別/食品工廠/醬料|調味品",
              },
              {
                EN: "Flour-based Products (Bread / Biscuits / Noodles)",
                JP: "小麦粉製品（パン／ビスケット／麺類）",
                label: "麵粉製品(麵包/餅乾/麵條)",
                href: "/商品資訊/產業類別/食品工廠/麵粉製品(麵包/餅乾/麵條)",
              },
              {
                EN: "Beverages (Juice / Tea / Coffee / Dairy / Alcoholic Beverages)",
                JP: "飲料（ジュース／紅茶／コーヒー／乳製品／アルコール飲料）",
                label: "飲料(果汁/茶飲/咖啡/乳品/酒精飲料)",
                href: "/商品資訊/產業類別/食品工廠/飲料(果汁/茶飲/咖啡/乳品/酒精飲料)",
              },
              {
                EN: "Snacks",
                JP: "スナック菓子",
                label: "零食",
                href:
                  "/商品資訊/產業類別(登入會員)/食品工廠/零食",
              },
              {
                EN: "Canned Foods",
                JP: "缶詰食品",
                label: "罐頭",
                href:
                  "/商品資訊/產業類別(登入會員)/食品工廠/罐頭",
              },
            ],
          },
          {
            EN: "Restaurant Chains",
            JP: "外食チェーン",
            label: "連鎖餐廳",
            href: "/商品資訊/產業類別/餐飲連鎖",
            login: "required",
            children: [
              {
                EN: "Fast-Food Brands (Chinese / Japanese / Korean / Western)",
                JP: "ファストフードブランド（中華／和食／韓国料理／欧米）",
                label: "速食品牌(中/日/韓/美)",
                href:
                  "/商品資訊/產業類別/速食品牌(中/日/韓/美)",
              },
              {
                EN: "Beverage Operators",
                JP: "飲料関連事業者",
                label: "飲料",
                href: "/商品資訊/產業類別/飲料",
              },
            ],
          },
          {
            EN: "Hypermarkets",
            JP: "量販店",
            label: "量販店",
            href: "/商品資訊/產業類別/量販店",
            login: "required",
          },
          {
            EN: "Supermarkets / Convenience Stores",
            JP: "スーパーマーケット／コンビニエンスストア",
            label: "超市/便利超商",
            href: "/商品資訊/產業類別/超市|便利超商",
            login: "required",
          },
          {
            EN: "Hotels",
            JP: "ホテル・旅館/民泊・簡易宿所",
            label: "飯店/民宿",
            href: "/商品資訊/產業類別/飯店|民宿",
            login: "required",
          },
        ],
      },

      {
        label: "人體接觸",
        EN: "Body Area",
        JP: "身体の部位から探す",
        href: "商品資訊/人體接觸",
        children: [
          {
            label: "頭",
            EN: "Head",
            JP: "頭部",
            href: "商品資訊/人體接觸/頭",
            children: [
              {
                label: "髮帽",
                EN: "Hair Caps",
                JP: "ヘアキャップ",
                href: "商品資訊/人體接觸/頭/髮帽",
              },
              {
                label: "護目鏡",
                EN: "Safety Goggles",
                JP: "保護メガネ",
                href: "商品資訊/人體接觸/頭/護目鏡",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href: "商品資訊/人體接觸/頭/口罩",
              },
            ],
          },
          {
            label: "手",
            EN: "Hands",
            JP: "手",
            href: "商品資訊/人體接觸/手",
            children: [
              {
                label: "手套",
                EN: "Protective Gloves",
                JP: "保護手袋",
                href: "商品資訊/人體接觸/手/手套",
                children: [
                  // {
                  //   label: "NBR手套",
                  //   EN: "Nitrile (NBR) Gloves",
                  //   JP: "ニトリル（NBR）手袋",
                  //   href:
                  //     "商品資訊/人體接觸/手/手套/NBR手套",
                  // },
                  // {
                  //   label: "PVC手套",
                  //   EN: "PVC Gloves",
                  //   JP: "PVC手袋",
                  //   href:
                  //     "商品資訊/人體接觸/手/手套/PVC手套",
                  // },
                  // {
                  //   label: "防切割手套",
                  //   EN: "Cut-Resistant Gloves",
                  //   JP: "耐切創手袋",
                  //   href:
                  //     "商品資訊/人體接觸/手/手套/防切割手套",
                  // },
                ],
              },
              {
                label: "袖套",
                EN: "Arm Sleeves",
                JP: "アームカバー",
                href: "商品資訊/人體接觸/手/袖套",
              },
              {
                label: "手部清潔",
                EN: "Hand Hygiene",
                JP: "手指衛生",
                href: "商品資訊/人體接觸/手/手部清潔",
                children: [
                  {
                    label: "洗手液/消毒液",
                    EN: "Hand Wash / Disinfectant",
                    JP: "手洗い用石鹸／消毒液",
                    href:
                      "商品資訊/人體接觸/手/手部清潔/洗手液|消毒液",
                  },
                  {
                    label: "手部清潔刷",
                    EN: "Hand Cleaning Brushes",
                    JP: "手洗い用ブラシ",
                    href:
                      "商品資訊/人體接觸/手/手部清潔/手部清潔刷",
                  },
                ],
              },
            ],
          },
          {
            label: "身",
            EN: "Body",
            JP: "体",
            href: "商品資訊/人體接觸/身體",
            children: [
              {
                label: "除塵黏紙",
                EN: "Adhesive Dust Removal Sheets",
                JP: "粘着ダストシート",
                href:
                  "商品資訊/人體接觸/身體/除塵黏紙",
              },
              {
                label: "工作服|防護服",
                EN: "Workwear / Uniforms",
                JP: "作業服／ユニフォーム",
                href:
                  "商品資訊/人體接觸/身體/工作服|防護服",
              },
              {
                label: "防護服",
                EN: "Protective Coveralls",
                JP: "防護服",
                href:
                  "商品資訊/人體接觸/身體/防護服",
              },
            ],
          },
          {
            label: "腳",
            EN: "Feet",
            JP: "足元",
            href: "商品資訊/人體接觸/腳",
            children: [
              {
                label: "工作鞋/防滑鞋",
                EN: "Safety / Anti-Slip Work Shoes",
                JP: "安全靴／滑り止めシューズ",
                href:
                  "商品資訊/人體接觸/腳/工作鞋|防滑鞋",
              },
              {
                label: "鞋套",
                EN: "Shoe Covers",
                JP: "シューズカバー",
                href: "商品資訊/人體接觸/腳/鞋套",
              },
              {
                label: "腳踏黏墊",
                EN: "Adhesive Floor Mats",
                JP: "粘着マット",
                href: "商品資訊/人體接觸/腳/腳踏黏墊",
              },
            ],
          },
        ],
      },

      {
        label: "使用區域",
        EN: "Usage Area",
        JP: "使用エリア別",
        href: "商品資訊/使用區域",
        children: [
           {
            label: "浴塵室",
            EN: "Air Shower",
            JP: "浴場",
            href: "/商品資訊/使用區域/浴塵室",
          },
          {
            label: "原料接收區",
            EN: "Receiving Area",
            JP: "原料受け入れ",
            href: "商品資訊/使用區域/原料接收區",
            children: [
              {
                label: "防撞桿",
                EN: "Crash Barriers",
                JP: "衝突防止ガード",
                href:
                  "商品資訊/使用區域/原料接收區/防撞桿",
              },
              {
                label: "區域標示",
                EN: "Zone Markings",
                JP: "ゾーン表示",
                href:
                  "商品資訊/使用區域/原料接收區/區域標示",
              },
              {
                label: "防護邊條",
                EN: "Protective Edge Guards",
                JP: "保護エッジガード",
                href:
                  "商品資訊/使用區域/原料接收區/防護邊條",
              },
              {
                label: "快速捲門",
                EN: "High-Speed Roll-Up Doors",
                JP: "高速ロールアップドア",
                href:
                  "商品資訊/使用區域/原料接收區/快速捲門",
              },
              {
                label: "防蟲門簾",
                EN: "Insect-Proof Curtains",
                JP: "防虫カーテン",
                href:
                  "商品資訊/使用區域/原料接收區/防蟲門簾",
              },
              {
                label: "忌避劑",
                EN: "Repellent Agents",
                JP: "忌避剤",
                href:
                  "商品資訊/使用區域/原料接收區/忌避劑",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Traps / Bug Lights (Glue Boards)",
                JP: "防虫／捕虫灯（捕虫紙）",
                href:
                  "商品資訊/使用區域/原料接收區/防蟲|捕蟲燈(捕蟲紙)",
              },
              {
                label: "手套",
                EN: "Gloves",
                JP: "手袋",
                href:
                  "商品資訊/使用區域/原料接收區/手套",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href:
                  "商品資訊/使用區域/原料接收區/口罩",
              },
              {
                label: "電潔水",
                EN: "Electrolyzed Water System",
                JP: "電解水システム",
                href:
                  "商品資訊/使用區域/原料接收區/電潔水",
              },
            ],
          },
          {
            label: "原料儲存區",
            EN: "Raw Storage",
            JP: "原料保管",
            href: "商品資訊/使用區域/原料儲存區",
            children: [
              {
                label: "區域標示",
                EN: "Zone Markings",
                JP: "ゾーン表示",
                href:
                  "商品資訊/使用區域/原料儲存區/區域標示",
              },
              {
                label: "防蟲門簾",
                EN: "Insect-Proof Curtains",
                JP: "防虫カーテン",
                href:
                  "商品資訊/使用區域/原料儲存區/防蟲門簾",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Traps / Bug Lights (Glue Boards)",
                JP: "防虫／捕虫灯（捕虫紙）",
                href:
                  "商品資訊/使用區域/原料儲存區/防蟲|捕蟲燈(捕蟲紙)",
              },
              {
                label: "手套",
                EN: "Gloves",
                JP: "手袋",
                href:
                  "商品資訊/使用區域/原料儲存區/手套",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href:
                  "商品資訊/使用區域/原料儲存區/口罩",
              },
              {
                label: "電潔水",
                EN: "Electrolyzed Water System",
                JP: "電解水システム",
                href:
                  "商品資訊/使用區域/原料儲存區/電潔水",
              },
            ],
          },
          {
            label: "員工更衣室",
            EN: "Changing Room",
            JP: "更衣室",
            href: "商品資訊/使用區域/員工更衣室",
            children: [
              {
                label: "髮帽",
                EN: "Hair Caps",
                JP: "ヘアキャップ",
                href:
                  "商品資訊/使用區域/員工更衣室/髮帽",
              },
              {
                label: "護目鏡",
                EN: "Safety Goggles",
                JP: "保護メガネ",
                href:
                  "商品資訊/使用區域/員工更衣室/護目鏡",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href:
                  "商品資訊/使用區域/員工更衣室/口罩",
              },
              {
                label: "袖套",
                EN: "Arm Sleeves",
                JP: "アームカバー",
                href:
                  "商品資訊/使用區域/員工更衣室/袖套",
              },
              {
                label: "工作服/防護服",
                EN: "Workwear / Protective Clothing",
                JP: "作業服／防護服",
                href:
                  "商品資訊/使用區域/員工更衣室/工作服|防護服",
              },
              {
                label: "工作鞋/防滑鞋",
                EN: "Work Shoes / Anti-Slip Shoes",
                JP: "作業靴／滑り止め靴",
                href:
                  "商品資訊/使用區域/員工更衣室/工作鞋|防滑鞋",
              },
              {
                label: "鞋套",
                EN: "Shoe Covers",
                JP: "シューズカバー",
                href:
                  "商品資訊/使用區域/員工更衣室/鞋套",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Traps / Bug Lights (Glue Boards)",
                JP: "防虫／捕虫灯（捕虫紙）",
                href:
                  "商品資訊/使用區域/員工更衣室/防蟲|捕蟲燈(捕蟲紙)",
              },
            ],
          },
          {
            label: "洗手消毒區",
            EN: "Handwashing & Disinfection",
            JP: "手洗い・消毒",
            href: "商品資訊/使用區域/洗手消毒區",
            children: [
              {
                label: "洗手設備",
                EN: "Handwashing Equipment (Wash / Sanitize / Dry)",
                JP: "手洗い設備（洗浄／消毒／乾燥）",
                href:
                  "商品資訊/使用區域/洗手消毒區/洗手設備",
              },
              {
                label: "手部清潔刷具",
                EN: "Hand Cleaning Brushes",
                JP: "手洗い用ブラシ",
                href:
                  "商品資訊/使用區域/洗手消毒區/手部清潔刷具",
              },
              {
                label: "洗手液",
                EN: "Hand Soap / Hand Wash",
                JP: "ハンドソープ",
                href:
                  "商品資訊/使用區域/洗手消毒區/洗手液",
              },
              {
                label: "消毒液",
                EN: "Disinfectant Solution",
                JP: "消毒液",
                href:
                  "商品資訊/使用區域/洗手消毒區/消毒液",
              },
              {
                label: "擦手紙",
                EN: "Paper Towels",
                JP: "ペーパータオル",
                href:
                  "商品資訊/使用區域/洗手消毒區/擦手紙",
              },
              {
                label: "除塵黏紙",
                EN: "Adhesive Dust Removal Sheets",
                JP: "粘着ダストシート",
                href:
                  "商品資訊/使用區域/洗手消毒區/除塵黏紙",
              },
              {
                label: "工作鞋/防滑鞋",
                EN: "Work Shoes / Anti-Slip Shoes",
                JP: "作業靴／滑り止め靴",
                href:
                  "商品資訊/使用區域/洗手消毒區/工作鞋|防滑鞋",
              },
              {
                label: "鞋套",
                EN: "Shoe Covers",
                JP: "シューズカバー",
                href:
                  "商品資訊/使用區域/洗手消毒區/鞋套",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href:
                  "商品資訊/使用區域/洗手消毒區/口罩",
              },
              {
                label: "泡沫洗手液",
                EN: "Foaming Hand Soap ",
                JP: "泡ハンドソープ ",
                href:
                  "商品資訊/使用區域/洗手消毒區/泡沫洗手液",
              },
              {
                label: "酒精除菌劑",
                EN: "Alcohol Sanitizer ",
                JP: "アルコール除菌剤 ",
                href:
                  "商品資訊/使用區域/洗手消毒區/酒精除菌劑",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Traps / Bug Lights (Glue Boards)",
                JP: "防虫／捕虫灯（捕虫紙）",
                href:
                  "商品資訊/使用區域/洗手消毒區/防蟲|捕蟲燈(捕蟲紙)",
              },
            ],
          },
          {
            label: "前處理區",
            EN: "Pre-Processing Area",
            JP: "前処理エリア",
            href: "商品資訊/使用區域/前處理區",
            children: [
              {
                label: "擦拭布",
                EN: "Wiping Cloths",
                JP: "清掃用クロス",
                href:
                  "商品資訊/使用區域/前處理區/擦拭布",
              },
              {
                label: "刷具",
                EN: "Cleaning Brushes",
                JP: "ブラシ",
                href:
                  "商品資訊/使用區域/前處理區/刷具",
              },
              {
                label: "洗手設備",
                EN: "Handwashing Equipment",
                JP: "手洗い設備",
                href:
                  "商品資訊/使用區域/前處理區/洗手設備",
              },
              {
                label: "消毒設備",
                EN: "Disinfection Equipment",
                JP: "消毒設備",
                href:
                  "商品資訊/使用區域/前處理區/消毒設備",
              },
              {
                label: "洗蔬果設備",
                EN: "Fruit & Vegetable Washing Equipment",
                JP: "果物・野菜洗浄設備",
                href:
                  "商品資訊/使用區域/前處理區/洗蔬果設備",
              },
              {
                label: "手套",
                EN: "Gloves",
                JP: "手袋",
                href:
                  "商品資訊/使用區域/前處理區/手套",
              },
              {
                label: "工作鞋/防滑鞋",
                EN: "Work Shoes / Anti-Slip Shoes",
                JP: "作業靴／滑り止め靴",
                href:
                  "商品資訊/使用區域/前處理區/工作鞋|防滑鞋",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href:
                  "商品資訊/使用區域/前處理區/口罩",
              },
              {
                label: "擦手紙",
                EN: "Paper Towels",
                JP: "ペーパータオル",
                href:
                  "商品資訊/使用區域/前處理區/擦手紙",
              },
              {
                label: "泡沫洗手液",
                EN: "Foaming Hand Soap ",
                JP: "泡ハンドソープ ",
                href:
                  "商品資訊/使用區域/前處理區/泡沫洗手液",
              },
              {
                label: "酒精除菌劑",
                EN: "Alcohol Sanitizer ",
                JP: "アルコール除菌剤 ",
                href:
                  "商品資訊/使用區域/前處理區/酒精除菌劑",
              },
              {
                label: "中性洗潔精",
                EN: "Neutral Detergent ",
                JP: "中性洗剤 ",
                href:
                  "商品資訊/使用區域/前處理區/中性洗潔精",
              },
              {
                label: "中性洗潔精",
                EN: "Neutral Detergent ",
                JP: "中性洗剤 ",
                href:
                  "商品資訊/使用區域/前處理區/中性洗潔精",
              },
              {
                label: "鹼性除菌清潔劑J-1",
                EN: "Alkaline Antibacterial Cleaner J-1",
                JP: "アルカリ性除菌洗浄剤 J-1",
                href:
                  "商品資訊/使用區域/前處理區/鹼性除菌清潔劑J-1",
              },
              {
                label: "泡沫去油清潔劑",
                EN: "Foaming Degreasing Cleaner",
                JP: "泡タイプ脱脂洗浄剤",
                href:
                  "商品資訊/使用區域/前處理區/泡沫去油清潔劑",
              },
              {
                label: "強力去油清潔劑",
                EN: "Heavy-Duty Degreasing Cleaner",
                JP: "強力脱脂洗浄剤",
                href:
                  "商品資訊/使用區域/前處理區/強力去油清潔劑",
              },
              {
                label: "除菌漂白劑",
                EN: "Sanitizing Bleach",
                JP: "除菌漂白剤",
                href:
                  "商品資訊/使用區域/前處理區/除菌漂白劑",
              },
              {
                label: "電潔水",
                EN: "Electrolyzed Water System",
                JP: "電解水システム",
                href:
                  "商品資訊/使用區域/前處理區/電潔水",
              },
              {
                label: "防蟲門簾",
                EN: "Insect-Proof Curtains",
                JP: "防虫カーテン",
                href:
                  "商品資訊/使用區域/前處理區/防蟲門簾",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Traps / Bug Lights (Glue Boards)",
                JP: "防虫／捕虫灯（捕虫紙）",
                href:
                  "商品資訊/使用區域/前處理區/防蟲|捕蟲燈(捕蟲紙)",
              },
              {
                label: "區域標示",
                EN: "Zone Markings",
                JP: "ゾーン表示",
                href:
                  "商品資訊/使用區域/前處理區/區域標示",
              },
              {
                label: "鞋套",
                EN: "Shoe Covers",
                JP: "シューズカバー",
                href:
                  "商品資訊/使用區域/前處理區/鞋套",
              },
            ],
          },
          {
            label: "加工/烹飪區",
            EN: "Processing / Cooking Area",
            JP: "加工・調理",
            href: "商品資訊/使用區域/加工|烹飪區",
            children: [
              {
                label: "擦手紙",
                EN: "Paper Towels",
                JP: "ペーパータオル",
                href:
                  "商品資訊/使用區域/加工|烹飪區/擦手紙",
              },
              {
                label: "洗手設備",
                EN: "Handwashing Equipment (Wash / Sanitize / Dry)",
                JP: "手洗い設備（洗浄／消毒／乾燥）",
                href:
                  "商品資訊/使用區域/加工|烹飪區/洗手設備",
              },
              {
                label: "泡沫洗手液",
                EN: "Foaming Hand Soap ",
                JP: "泡ハンドソープ ",
                href:
                  "商品資訊/使用區域/加工|烹飪區/泡沫洗手液",
              },
              {
                label: "酒精除菌劑",
                EN: "Alcohol Sanitizer ",
                JP: "アルコール除菌剤 ",
                href:
                  "商品資訊/使用區域/加工|烹飪區/酒精除菌劑",
              },
              {
                label: "中性洗潔精",
                EN: "Neutral Detergent ",
                JP: "中性洗剤 ",
                href:
                  "商品資訊/使用區域/加工|烹飪區/中性洗潔精",
              },
              {
                label: "中性洗潔精",
                EN: "Neutral Detergent ",
                JP: "中性洗剤 ",
                href:
                  "商品資訊/使用區域/加工|烹飪區/中性洗潔精",
              },
              {
                label: "鹼性除菌清潔劑J-1",
                EN: "Alkaline Antibacterial Cleaner J-1",
                JP: "アルカリ性除菌洗浄剤 J-1",
                href:
                  "商品資訊/使用區域/加工|烹飪區/鹼性除菌清潔劑J-1",
              },
              {
                label: "泡沫去油清潔劑",
                EN: "Foaming Degreasing Cleaner",
                JP: "泡タイプ脱脂洗浄剤",
                href:
                  "商品資訊/使用區域/加工|烹飪區/泡沫去油清潔劑",
              },
              {
                label: "強力去油清潔劑",
                EN: "Heavy-Duty Degreasing Cleaner",
                JP: "強力脱脂洗浄剤",
                href:
                  "商品資訊/使用區域/加工|烹飪區/強力去油清潔劑",
              },
              {
                label: "除菌漂白劑",
                EN: "Sanitizing Bleach",
                JP: "除菌漂白剤",
                href:
                  "商品資訊/使用區域/加工|烹飪區/除菌漂白劑",
              },
              {
                label: "擦拭布",
                EN: "Wiping Cloths",
                JP: "清掃用クロス",
                href:
                  "商品資訊/使用區域/加工|烹飪區/擦拭布",
              },
              {
                label: "刷具",
                EN: "Cleaning Brushes",
                JP: "ブラシ",
                href:
                  "商品資訊/使用區域/加工|烹飪區/刷具",
              },
              {
                label: "攪拌棒",
                EN: "Mixing Sticks",
                JP: "攪拌棒",
                href:
                  "商品資訊/使用區域/加工|烹飪區/攪拌棒",
              },
              {
                label: "手套",
                EN: "Gloves",
                JP: "手袋",
                href:
                  "商品資訊/使用區域/加工|烹飪區/手套",
              },
              {
                label: "工作鞋/防滑鞋",
                EN: "Work Shoes / Anti-Slip Shoes",
                JP: "作業靴／滑り止め靴",
                href:
                  "商品資訊/使用區域/加工|烹飪區/工作鞋|防滑鞋",
              },
              {
                label: "鞋套",
                EN: "Shoe Covers",
                JP: "シューズカバー",
                href:
                  "商品資訊/使用區域/加工|烹飪區/鞋套",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href:
                  "商品資訊/使用區域/加工|烹飪區/口罩",
              },
              {
                label: "電潔水",
                EN: "Electrolyzed Water System",
                JP: "電解水システム",
                href:
                  "商品資訊/使用區域/加工|烹飪區/電潔水",
              },
              {
                label: "防蟲門簾",
                EN: "Insect-Proof Curtains",
                JP: "防虫カーテン",
                href:
                  "商品資訊/使用區域/加工|烹飪區/防蟲門簾",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Traps / Bug Lights (Glue Boards)",
                JP: "防虫／捕虫灯（捕虫紙）",
                href:
                  "商品資訊/使用區域/加工|烹飪區/防蟲|捕蟲燈(捕蟲紙)",
              },
              {
                label: "區域標示",
                EN: "Zone Markings",
                JP: "ゾーン表示",
                href:
                  "商品資訊/使用區域/加工|烹飪區/區域標示",
              },
              {
                label: "消毒設備",
                EN: "Disinfection Equipment",
                JP: "消毒設備",
                href:
                  "商品資訊/使用區域/加工|烹飪區/消毒設備",
              },
            ],
          },
          {
            label: "包裝區",
            EN: "Packaging Area",
            JP: "包装エリア",
            href: "商品資訊/使用區域/包裝區",
            children: [
              {
                label: "保鮮膜",
                EN: "Cling Film",
                JP: "ラップフィルム",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜",
              },
              {
                label: "食品包材",
                EN: "Food Packaging Materials",
                JP: "食品包装資材",
                href:
                  "商品資訊/使用區域/包裝區/食品包材",
              },
              {
                label: "手套",
                EN: "Gloves",
                JP: "手袋",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/手套",
              },
              {
                label: "工作鞋/防滑鞋",
                EN: "Work Shoes / Anti-Slip Shoes",
                JP: "作業靴／滑り止め靴",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/工作鞋|防滑鞋",
              },
              {
                label: "鞋套",
                EN: "Shoe Covers",
                JP: "シューズカバー",
                href:
                  "商品資訊/使用區域/前處理區/鞋套",
              },
              {
                label: "洗手設備",
                EN: "Handwashing Equipment (Wash / Sanitize / Dry)",
                JP: "手洗い設備（洗浄／消毒／乾燥）",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/洗手設備",
              },
              {
                label: "消毒設備",
                EN: "Disinfection Equipment",
                JP: "消毒設備",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/消毒設備",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/口罩",
              },
              {
                label: "電潔水",
                EN: "Electrolyzed Water System",
                JP: "電解水システム",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/電潔水",
              },
              {
                label: "擦手紙",
                EN: "Paper Towels",
                JP: "ペーパータオル",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/擦手紙",
              },
              {
                label: "泡沫洗手液",
                EN: "Foaming Hand Soap ",
                JP: "泡ハンドソープ ",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/泡沫洗手液",
              },
              {
                label: "酒精除菌劑",
                EN: "Alcohol Sanitizer ",
                JP: "アルコール除菌剤 ",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/酒精除菌劑",
              },
              {
                label: "中性洗潔精",
                EN: "Neutral Detergent ",
                JP: "中性洗剤 ",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/中性洗潔精",
              },
              {
                label: "中性洗潔精",
                EN: "Neutral Detergent ",
                JP: "中性洗剤 ",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/中性洗潔精",
              },
              {
                label: "鹼性除菌清潔劑J-1",
                EN: "Alkaline Antibacterial Cleaner J-1",
                JP: "アルカリ性除菌洗浄剤 J-1",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/鹼性除菌清潔劑J-1",
              },
              {
                label: "泡沫去油清潔劑",
                EN: "Foaming Degreasing Cleaner",
                JP: "泡タイプ脱脂洗浄剤",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/泡沫去油清潔劑",
              },
              {
                label: "強力去油清潔劑",
                EN: "Heavy-Duty Degreasing Cleaner",
                JP: "強力脱脂洗浄剤",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/強力去油清潔劑",
              },
              {
                label: "除菌漂白劑",
                EN: "Sanitizing Bleach",
                JP: "除菌漂白剤",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/除菌漂白劑",
              },
              {
                label: "防蟲門簾",
                EN: "Insect-Proof Curtains",
                JP: "防虫カーテン",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/防蟲門簾",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Traps / Bug Lights (Glue Boards)",
                JP: "防虫／捕虫灯（捕虫紙）",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/防蟲|捕蟲燈(捕蟲紙)",
              },
              {
                label: "區域標示",
                EN: "Zone Markings",
                JP: "ゾーン表示",
                href:
                  "商品資訊/使用區域/包裝區/保鮮膜/區域標示",
              },
            ],
          },
          {
            label: "實驗/檢驗室(品管與食品安全檢測)",
            EN: "Laboratory / Inspection (QC & Food Safety)",
            JP: "実験・検査室（品質管理・食品安全）",
            href:
              "商品資訊/使用區域/實驗/檢驗室(品管與食品安全檢測)",
            children: [
              {
                label: "手套",
                EN: "Gloves",
                JP: "手袋",
                href:
                  "商品資訊/使用區域/實驗/檢驗室(品管與食品安全檢測)/手套",
              },
              {
                label: "鞋套",
                EN: "Shoe Covers",
                JP: "シューズカバー",
                href:
                  "商品資訊/使用區域/實驗/檢驗室(品管與食品安全檢測)",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href:
                  "商品資訊/使用區域/實驗/檢驗室(品管與食品安全檢測)/口罩",
              },
              {
                label: "電潔水",
                EN: "Electrolyzed Water System",
                JP: "電解水システム",
                href:
                  "商品資訊/使用區域/實驗/檢驗室(品管與食品安全檢測)/電潔水",
              },
              {
                label: "區域標示",
                EN: "Zone Markings",
                JP: "ゾーン表示",
                href:
                  "商品資訊/使用區域/實驗/檢驗室(品管與食品安全檢測)/區域標示",
              },
            ],
          },
          {
            label: "成品儲存區",
            EN: "Storage Area",
            JP: "製品保管エリア",
            href: "商品資訊/使用區域/成品儲存區",
            children: [
              {
                label: "忌避劑",
                EN: "Repellent Agents",
                JP: "忌避剤",
                href:
                  "商品資訊/使用區域/成品儲存區/忌避劑",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Traps / Bug Lights (Glue Boards)",
                JP: "防虫／捕虫灯（捕虫紙）",
                href:
                  "商品資訊/使用區域/成品儲存區/防蟲|捕蟲燈(捕蟲紙)",
              },
              {
                label: "手套",
                EN: "Gloves",
                JP: "手袋",
                href:
                  "商品資訊/使用區域/成品儲存區/手套",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href:
                  "商品資訊/使用區域/成品儲存區/口罩",
              },
              {
                label: "電潔水",
                EN: "Electrolyzed Water System",
                JP: "電解水システム",
                href:
                  "商品資訊/使用區域/成品儲存區/電潔水",
              },
              {
                label: "防蟲門簾",
                EN: "Insect-Proof Curtains",
                JP: "防虫カーテン",
                href:
                  "商品資訊/使用區域/成品儲存區/防蟲門簾",
              },
              {
                label: "區域標示",
                EN: "Zone Markings",
                JP: "ゾーン表示",
                href:
                  "商品資訊/使用區域/成品儲存區/區域標示",
              },
            ],
          },
          {
            label: "出貨區",
            EN: "Shipping Area",
            JP: "出荷エリア",
            href: "商品資訊/使用區域/出貨區",
            children: [
              {
                label: "防撞桿",
                EN: "Crash Barriers",
                JP: "衝突防止ガード",
                href:
                  "商品資訊/使用區域/出貨區/防撞桿",
              },
              {
                label: "區域標示",
                EN: "Zone Markings",
                JP: "ゾーン表示",
                href:
                  "商品資訊/使用區域/出貨區/區域標示",
              },
              {
                label: "防護邊條",
                EN: "Protective Edge Guards",
                JP: "保護エッジガード",
                href:
                  "商品資訊/使用區域/出貨區/防護邊條",
              },
              {
                label: "快速捲門",
                EN: "High-Speed Roll-Up Doors",
                JP: "高速ロールアップドア",
                href:
                  "商品資訊/使用區域/出貨區/快速捲門",
              },
              {
                label: "防蟲門簾",
                EN: "Insect-Proof Curtains",
                JP: "防虫カーテン",
                href:
                  "商品資訊/使用區域/出貨區/防蟲門簾",
              },
              {
                label: "忌避劑",
                EN: "Repellent Agents",
                JP: "忌避剤",
                href:
                  "商品資訊/使用區域/出貨區/忌避劑",
              },
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Traps / Bug Lights (Glue Boards)",
                JP: "防虫／捕虫灯（捕虫紙）",
                href:
                  "商品資訊/使用區域/出貨區/防蟲|捕蟲燈(捕蟲紙)",
              },
              {
                label: "手套",
                EN: "Gloves",
                JP: "手袋",
                href:
                  "商品資訊/使用區域/出貨區/手套",
              },
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href:
                  "商品資訊/使用區域/出貨區/口罩",
              },
              {
                label: "電潔水",
                EN: "Electrolyzed Water System",
                JP: "電解水システム",
                href:
                  "商品資訊/使用區域/出貨區/電潔水",
              },
              {
                label: "區域標示",
                EN: "Zone Markings",
                JP: "ゾーン表示",
                href:
                  "商品資訊/使用區域/出貨區/區域標示",
              },
            ],
          },
          {
            label: "廢棄物處理區",
            EN: "Waste Disposal Area",
            JP: "廃棄物処理エリア",
            href: "商品資訊/使用區域/廢棄物處理區",
            children: [
              {
                label: "防蟲/捕蟲燈(捕蟲紙)",
                EN: "Insect Traps / Bug Lights (Glue Boards)",
                JP: "防虫／捕虫灯（捕虫紙）",
                href:
                  "商品資訊/使用區域/廢棄物處理區/防蟲|捕蟲燈(捕蟲紙)",
              },
              {
                label: "手套",
                EN: "Gloves",
                JP: "手袋",
                href:
                  "商品資訊/使用區域/廢棄物處理區/手套",
              },
              {
                label: "區域標示",
                EN: "Zone Markings",
                JP: "ゾーン表示",
                href:
                  "商品資訊/使用區域/廢棄物處理區/區域標示",
              },
            ],
          },
          {
            label: "辦公區",
            EN: "Office Area",
            JP: "事務室",
            href: "商品資訊/使用區域/辦公區",
            children: [
              {
                label: "口罩",
                EN: "Face Masks",
                JP: "マスク",
                href:
                  "商品資訊/使用區域/辦公區/口罩",
              },
              {
                label: "電潔水",
                EN: "Electrolyzed Water System",
                JP: "電解水システム",
                href:
                  "商品資訊/使用區域/辦公區/電潔水",
              },
              {
                label: "防蟲|捕蟲燈(捕蟲紙)",
                EN: "Insect Traps / Bug Lights (Glue Boards)",
                JP: "防虫／捕虫灯（捕虫紙）",
                href:
                  "商品資訊/使用區域/辦公區/防蟲|捕蟲燈(捕蟲紙)",
              },
            ],
          },
          {
            label: "洗手間",
            EN: "Restroom Area",
            JP: "エアシャワー室",
            href: "商品資訊/使用區域/洗手間",
            children: [
              {
                label: "洗手設備",
                EN: "Handwashing Fixtures",
                JP: "手洗い設備",
                href:
                  "商品資訊/使用區域/洗手間/洗手設備",
              },
              {
                label: "洗手液",
                EN: "Hand Soap",
                JP: "ハンドソープ",
                href:
                  "商品資訊/使用區域/洗手間/洗手液",
              },
              {
                label: "消毒液",
                EN: "Disinfectant Solution",
                JP: "消毒液",
                href:
                  "商品資訊/使用區域/洗手間/消毒液",
              },
              {
                label: "擦手紙",
                EN: "Paper Towels",
                JP: "ペーパータオル",
                href:
                  "商品資訊/使用區域/洗手間/擦手紙",
              },
              {
                label: "泡沫洗手液",
                EN: "Foaming Hand Soap ",
                JP: "泡ハンドソープ ",
                href:
                  "商品資訊/使用區域/洗手間/泡沫洗手液",
              },
              {
                label: "酒精除菌劑",
                EN: "Alcohol Sanitizer ",
                JP: "アルコール除菌剤 ",
                href:
                  "商品資訊/使用區域/洗手間/酒精除菌劑",
              },
            ],
          },
        ],
      },
      {
        EN: "Professional Consultation",
        JP: "専門コンサルティング",
        label: "專業諮詢",
        href: "/商品資訊/專業諮詢(專人服務)",
      },
    ],
  },
];

export default ProductSideBarConfigB2B;
